import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import {DialogService } from "@progress/kendo-angular-dialog";
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/http/api.service';
import { NotificationService } from '@progress/kendo-angular-notification';



@Component({
  selector: 'app-lockers-edit-component',
  templateUrl: './lockers-edit.component.html',
})
export class LockersEditComponent implements OnInit {
  public form!: FormGroup;
  public prePagoControls: Array<{ label: string, control: FormControl }> = [];
  public posPagoControls: Array<{ label: string, control: FormControl }> = [];
  public customMsgService: CustomMessagesService;


  constructor(private fb: FormBuilder, public msgService: MessageService, private dialogService: DialogService, private router: Router, private api: ApiService, private notificationService: NotificationService,) {
    this.customMsgService = this.msgService as CustomMessagesService;
    this.initializeForm();
  }

  ngOnInit() {}

  private initializeForm(): void {
    this.form = this.fb.group({});

    const labels = ['S', 'M', 'L', 'XL'];

    labels.forEach(label => {
      const prePagoControl = new FormControl('', [
        Validators.required,
        this.decimalValidator
      ]);
      const posPagoControl = new FormControl('', [
        Validators.required,
        this.decimalValidator
      ]);

      this.prePagoControls.push({ label, control: prePagoControl });
      this.posPagoControls.push({ label, control: posPagoControl });

      this.form.addControl('prePago' + label, prePagoControl);
      this.form.addControl('posPago' + label, posPagoControl);
    });
  }

  decimalValidator(control: FormControl): { [key: string]: boolean } | null {
    if (!control.value) return null;
    const value = parseFloat(control.value);
    if (isNaN(value)) return { invalidNumber: true };
    const decimalPart = Math.round((value * 100) % 100);
    if (decimalPart % 5 !== 0) {
      return { invalidDecimal: true };
    }
    return null;
  }

  onSave() {
    if (this.form.valid) {
      console.log('Form data:', this.form.value);
      // Add the code to save the data here.
    }
  }
}
